import { Component, Input, OnChanges } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { TomoDashboardBranch } from '../services/api/dashboard.service';

/**
 * Dashboard de Informes Médicos: Sucursales HOY. Mismo gráfico del dashboard general, pero cuenta
 * solo las órdenes que tienen al menos un estudio TOMO en cada sucursal.
 */
@Component({
    selector: 'app-tomo-branches-today',
    standalone: true,
    imports: [ChartModule],
    templateUrl: './tomo-branches-today.component.html'
})
export class TomoBranchesTodayComponent implements OnChanges {
    @Input() branches: TomoDashboardBranch[] = [];

    chartData: any;
    chartOptions: any;

    ngOnChanges(): void {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        this.chartData = {
            labels: this.branches.map((b) => b.branchName),
            datasets: [
                {
                    label: 'Órdenes con Tomografía',
                    data: this.branches.map((b) => b.orderCount),
                    fill: false,
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-500'),
                    borderColor: documentStyle.getPropertyValue('--p-primary-500'),
                    tension: 0.4
                }
            ]
        };

        this.chartOptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: { legend: { labels: { color: textColor } } },
            scales: {
                x: { ticks: { color: textColorSecondary }, grid: { color: surfaceBorder, drawBorder: false } },
                y: { ticks: { color: textColorSecondary }, grid: { color: surfaceBorder, drawBorder: false } }
            }
        };
    }
}
